import styled from 'styled-components';

import { Div, P } from 'common/styles/oc-styled-components';
import { BREAKPOINTS, colors } from 'common/styles/style-constants';
import { DIMENSIONS } from 'providers/WindowDimensionsProvider';

export const LabelContainer = styled(P)`
  display: flex;
  align-items: baseline;
  color: #6f6a71;
  font-size: 14px;
  padding-top: 12px;
  margin: ${props =>
    (props.layout === DIMENSIONS.MOBILE ? '-.5em 0 0 0' : '0 0 10px')};
`;

export const IconWrapper = styled.span`
  display: inline-flex;
  justify-content: center;
  align-items: center;
  margin-left: 5px;
  position: relative;
  .anticon svg {
    position: absolute;
    bottom: -2px;
    &:hover {
      cursor: pointer;
    }
  }
  @media (max-width: ${BREAKPOINTS.mobileMax}px) {
    display: none;
  }
`;

export const MobileDisclaimer = styled(Div)`
  && {
    color: ${colors.sage7};
    margin-top: 2px;
    margin-bottom: 10px;
    font-size: 12px;
    a {
      color: ${colors.sage7};
    }
    border: 1px solid ${colors.sage7};
    padding: 5px 10px;
  }
`;

export const LabelTooltip = styled.div`
  position: absolute;
  width: 500px;
  left: 25px;

  padding: 5px 10px;
  color: ${colors.sage7};
  background-color: #f8fcfc;
  z-index: 2;
  border: 1px solid ${colors.sage7};
  border-radius: 3px;
  font-size: 12px;
  margin-block: 0;

  opacity: ${props => props.opacity};
  transition: all 0.4s;
`;
